<h1 mat-dialog-title>Edit Change Set on {{ this.data.effectiveDate | date: 'medium' }}</h1>
<div>
  <form [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
    <div mat-dialog-content>
      <mat-form-field id="effective-date">
        <input
          formControlName="effectiveDate"
          matInput
          [min]="minDate"
          [matDatepicker]="picker"
          placeholder="Effective Date"
          readonly="true"
          (dateChange)="onDateChanged($event)"
          >
        <mat-datepicker-toggle
          data-testid="datepicker_toggle"
          [disabled]="!changeSet"
          [for]="picker"
          matSuffix
        ></mat-datepicker-toggle>
        <mat-datepicker #picker [dateClass]="highlightDate"></mat-datepicker>
        @if (form.controls['effectiveDate'].errors?.changeSetExists) {
          <mat-error>
            Please select another date with no existing change set.
          </mat-error>
        }
        @if (dateChanged) {
          <mat-hint>
            This will move <strong>ALL CHANGES</strong> for <strong>ALL SUBMENUS</strong> to the newly selected effective date.
          </mat-hint>
        }
        @if (dateChangedToToday) {
          <mat-hint>
            IMPORTANT: This change set will now be applied to the current menu immediately.
          </mat-hint>
        }
      </mat-form-field>
    </div>
    @if (!isReadOnlyScope) {
      <div class="mt-2 mb-0" mat-dialog-actions>
        <button
          [attr.data-testid]="'cancel_button'"
          class="button-color"
          mat-raised-button
          matTooltip="Cancel"
          type="button"
          (click)="cancelChangeSet()"
          >
          Cancel
        </button>
        <button
          [attr.data-testid]="'change_set_button'"
          class="button-color"
          [disabled]="form.pristine || form.invalid || (isReadOnly$ | async) || disableSubmit"
          mat-raised-button
          matTooltip="Save"
          type="submit"
          >
          Reschedule
        </button>
        @if (dateChanged || dateChangedToToday) {
          <div class="pl-2 pt-2">
            <mat-error>
              <mat-icon class="icon">update</mat-icon>
              @if (dateChangedToToday) {
                <mat-icon class="icon">priority_high</mat-icon>
              }
            </mat-error>
          </div>
        }
      </div>
    }
  </form>
</div>
